import * as Yup from 'yup';

export default Yup.object().shape({
  password: Yup.string().required('Campo obrigatório'),
  passwordConfirmation: Yup.string()
    .oneOf([Yup.ref('password'), null], 'As senhas devem ser iguais')
    .required('Campo obrigatório'),
});
